/* eslint-disable array-callback-return */
/* eslint-disable no-unused-vars */
/* eslint-disable no-sequences */
import React from 'react';
import Components from 'mpm-components';
import Services from 'mpm-services';
import { Button, Icon, Divider, Step } from 'semantic-ui-react';
import StepDetails from './sections/StepDetails';
import StepSources from './sections/StepSources';
import StepTransport from './sections/StepTransport';
import StepRecap from './sections/StepRecap';
import { CessionExportView } from 'mpm-classes/CessionExport';
import * as Constants from 'mpm-config/Constants';
import { toClass } from 'class-converter';

export default ({ selectedCessionExportId, onComplet, setMessage, entities, pays, typesTransformations }) => {
  const [cessionExport, setCessionExport] = React.useState(null);
  const [loading, setLoading] = React.useState(true);
  const [isError, setIsError] = React.useState(false);
  const [step, setStep] = React.useState(1);
  const [saving, setSaving] = React.useState(false);
  const [validating, setValidating] = React.useState(false);
  const [editMode, setEditMode] = React.useState(false);

  React.useEffect(() => {
    if (!selectedCessionExportId) {
      setCessionExport(new CessionExportView());
      setLoading(false);
      setEditMode(false);
    } else {
      setEditMode(true);
      Services.CessionsExportDataService.getForEdit(selectedCessionExportId)
        .then((response) => {
          let data = toClass(response.data, CessionExportView);
          data.childrenSourceEXP.map((elem) => {
            elem.childrenSrcEsp &&
              elem.childrenSrcEsp.length > 0 &&
              elem.childrenSrcEsp.map((esp) => {
                esp.selected = true;
              });
          });
          setCessionExport(data);
          setLoading(false);
          setIsError(false);
        })
        .catch((err) => {
          setIsError(true);
          setLoading(false);
        });
    }
  }, [selectedCessionExportId]);

  const onClickNext = () => {
    if (step === 1) {
      if (cessionExport.certificatManuelle && !cessionExport.numeroCertificat) {
        setMessage({
          warning: true,
          header: 'Validation',
          content: 'Numéro Cértificat Exportation SAP est obligatoire',
        });
        return;
      }
      if (cessionExport.certificatManuelle && !cessionExport.dateVisa) {
        setMessage({
          warning: true,
          header: 'Validation',
          content: 'Date Cértificat Exportation SAP est obligatoire',
        });
        return;
      }

      if (!cessionExport.dateCession) {
        setMessage({
          warning: true,
          header: 'Validation',
          content: 'Date Demande Exportation est obligatoire',
        });
        return;
      }
      if (!cessionExport.id_RefDpmValid) {
        setMessage({
          warning: true,
          header: 'Validation',
          content: 'DPM de validation est obligatoire',
        });
        return;
      }
    }
    if (step === 2) {
      let isValid = false;
      let messages = [];
      cessionExport.childrenSourceEXP &&
        cessionExport.childrenSourceEXP.forEach((element) => {
          if (element.sourceEXPList && element.sourceEXPList.length > 0) {
            isValid = true;
          }
          if (element.childrenSrcEsp.length === 0) {
            messages.push(`Séléctionner au minimum une éspece pour cette source ${element.codeSource}, ou supprimer cette source.`);
            isValid = false;
          } else {
            element.childrenSrcEsp.forEach((elemEspece) => {
              if (elemEspece.poidExporte && Number(elemEspece.poidExporte).toFixed(2) === Number(0).toFixed(2)) {
                isValid = false;
                messages.push(`La quantité Exportée de l'espece ${elemEspece.refEspece.libelle}, de la source ${element.codeSource} doit êtres supérieur a 0`);
              }
              if (elemEspece.selected && !elemEspece.codeSH) {
                isValid = false;
                messages.push(`Le Code SH de l'espece ${elemEspece.refEspece.libelle}, de la source ${element.codeSource} est obligatoire`);
              }
            });
          }
        });

      if (!isValid && messages.length === 0) {
        setMessage({
          warning: true,
          header: 'Validation',
          content: 'Source obligatoire!',
        });
        return;
      } else if (!isValid && messages.length > 0) {
        setMessage({
          warning: true,
          header: 'Validation',
          isArray: true,
          content: messages,
        });
        return;
      }
    }

    if (step === 3) {
      if (!cessionExport.id_RefPaysExp) {
        setMessage({
          warning: true,
          header: 'Validation',
          content: "Pays d'exportation obligatoire!",
        });
        return;
      }
      if (!cessionExport.lieuDepart) {
        setMessage({
          warning: true,
          header: 'Validation',
          content: 'Port / Aéroport / Autre Lieu de départ est obligatoire!',
        });
        return;
      }
    }
    setStep(step + 1);
    setMessage(null);
  };
  const onClickPrevious = () => {
    setStep(step - 1);
    setMessage(null);
  };

  const onSave = () => {
    setSaving(true);
    let toBeSaved = toClass(
      {
        ...cessionExport,
        childrenSourceEXP: cessionExport.childrenSourceEXP?.sort((a, b) => (!a.id ? 0 : !b.id ? -1 : a.id > b.id ? 1 : a.id < b.id ? -1 : 0)),
      },
      CessionExportView
    );
    Services.CessionsExportDataService.create({ ...toBeSaved })
      .then((result) => {
        if (result.success) {
          setCessionExport({ ...cessionExport, ...result.data });
          setSaving(false);
          setMessage({
            success: true,
            header: 'Enregistrement Cession Export',
            content: "Votre cession d'exportation a été enregistré avec succée!",
          });
        } else {
          setMessage({
            warning: true,
            header: 'Enregistrement Cession Export',
            content: result.message,
          });
          setSaving(false);
        }
      })
      .catch((error) => {
        setMessage({
          error: true,
          header: 'Enregistrement Cession Export',
          content: "Une erreur est survenue lors d'enregistrement de cession d'exportation",
        });
        setSaving(false);
      });
  };

  const onValidate = () => {
    let data = {
      ...cessionExport,
    };
    setValidating(true);
    Services.CessionsExportDataService.validate(data)
      .then((result) => {
        if (result.success) {
          setCessionExport({ ...cessionExport, etat: result.data.etat });
          setMessage({
            success: true,
            header: 'Validation Cession Export',
            content: "Votre cession d'exportation a été validé avec succée",
          });
          setValidating(false);
          onComplet(true, {
            numeroCessionComplet: result.data.numeroCessionComplet,
          });
        } else {
          setMessage({
            error: true,
            header: 'Validation Cession Export',
            content: result.message,
          });
          setValidating(false);
        }

        //
      })
      .catch((error) => {
        setMessage({
          error: true,
          header: 'Validation Cession Export',
          content: "Une erreur est survenue lors de validation de cession d'exportation",
        });
        setValidating(false);
      });
  };

  const isDisabledButtonNext = () => {
    return step === 4;
  };

  return loading ? (
    <Components.MPMLoader message="chargement en cours, veuillez patienter !" hideLogo />
  ) : isError ? (
    <Components.MPMError />
  ) : (
    <>
      <Step.Group ordered fluid size="small" unstackable={true}>
        <Step active={step === 1} completed={step > 1} disabled={step < 1}>
          <Step.Content>
            <Step.Title>Cession Export</Step.Title>
          </Step.Content>
        </Step>
        <Step active={step === 2} completed={step > 2} disabled={step < 2}>
          <Step.Content>
            <Step.Title>Sources - Especes</Step.Title>
          </Step.Content>
        </Step>
        <Step active={step === 3} completed={step > 3} disabled={step < 3}>
          <Step.Content>
            <Step.Title>Infos Relatives Au Transport</Step.Title>
          </Step.Content>
        </Step>
        <Step active={step === 4} completed={step > 4} disabled={step < 4}>
          <Step.Content>
            <Step.Title>Validation</Step.Title>
          </Step.Content>
        </Step>
      </Step.Group>
      {step === 1 && <StepDetails entities={entities} editMode={editMode} cessionExport={cessionExport} setMessage={(data) => setMessage(data)} setCessionExport={(cession) => setCessionExport(cession)} />}
      {step === 2 && <StepSources editMode={editMode} typesTransformations={typesTransformations} cessionExport={cessionExport} onComplet={(force) => onComplet(force)} setMessage={(data) => setMessage(data)} setCessionExport={(cession) => setCessionExport(cession)} />}
      {step === 3 && <StepTransport pays={pays} editMode={editMode} cessionExport={cessionExport} setMessage={(data) => setMessage(data)} setCessionExport={(cession) => setCessionExport(cession)} />}

      {step === 4 && <StepRecap entities={entities} pays={pays} editMode={editMode} cessionExport={cessionExport} setMessage={(data) => setMessage(data)} setCessionExport={(cession) => setCessionExport(cession)} />}

      <Divider />
      <Button icon className="full-width" labelPosition="left" onClick={() => onComplet()} size="tiny" disabled={saving || validating}>
        <Icon name="arrow left" />
        Retour
      </Button>
      {cessionExport.etat !== Constants.CC_ETAT_VALIDER && (
        <>
          <Button icon className="full-width" labelPosition="left" onClick={() => onSave()} loading={saving} primary size="tiny" disabled={step !== 4 || saving || validating}>
            <Icon name="save" />
            Enregitrer
          </Button>
          <Button icon className="full-width" labelPosition="left" onClick={() => onValidate()} loading={validating} positive size="tiny" disabled={step !== 4 || saving || validating}>
            <Icon name="check" />
            Valider
          </Button>
        </>
      )}
      <Button icon className="full-width" labelPosition="right" onClick={() => onClickNext()} disabled={isDisabledButtonNext()} size="tiny" floated="right">
        <Icon name="chevron right" />
        Suivant
      </Button>
      <Button icon className="full-width" labelPosition="left" onClick={() => onClickPrevious()} disabled={step === 1 ? true : false} size="tiny" floated="right">
        <Icon name="chevron left" />
        Précédent
      </Button>
    </>
  );
};
